import React from "react"

export const OneCoffee = () => <span role='img' aria-label="one coffee">&#9749;</span>
export const TwoCoffee = () => (
    <span role='img' aria-label="two coffee">&#9749; &#9749;</span>
)
